<template>
  <v-container class="pa-0" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="sales" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-4">
            <p class="display-1 font-weight-bold mb-0 pb-0">
              Pedidos
            </p>
          </v-col>
          <!-- Columna para el botón de agregar una venta -->
          <v-col cols="12" md="5" class="mb-4">
            <PrimaryButton @click="$router.push({ name: 'new-order' })">
              Nuevo pedido
            </PrimaryButton>
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Items -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando pedidos
          </LinearLoading>
        </LoadingLayout>
        <!-- Pedidos -->
        <template>
          <OrderItem
            v-for="item in sales.docs"
            :key="item._id"
            :saleData="item"
            @sale-deleted="saleDeleted"
            @sale-error="onSalesError"
          />
        </template>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar componentes
import PaginatedLayout from "@/layouts/PaginatedLayout";
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import SnackbarMessage from "@/components/SnackbarMessage";
import OrderItem from "@/components/movements/OrderItem";
import BranchSelector from "@/components/BranchSelector";
import DeltiaCard from "@/components/DeltiaCard";
import PrimaryButton from "@/components/PrimaryButton";

// Importar dependencias
import { mapGetters } from "vuex";

// importar servicios
import MovementsServices from "@/services/MovementsServices";

// Importamos mixins
import salesStatuses from "@/mixins/salesStatuses.js";

export default {
  name: "Sales",
  mixins: [salesStatuses],
  components: {
    LoadingLayout,
    LinearLoading,
    SnackbarMessage,
    PaginatedLayout,
    OrderItem,
    PrimaryButton,
    DeltiaCard
  },
  data: function() {
    return {
      isLoading: true,
      sales: { docs: [] },
      selectedBranchId: null,
      status: [{ type: "all", name: "Todos los estados" }],
      selectedStatus: "all"
    };
  },
  mounted: async function() {
    if (this.getProfile.testing_orders) {
      await this.updatePage();
    }
  },
  computed: {
    ...mapGetters(["getProfile"])
  },
  methods: {
    updatePage: async function(page = 1) {
      try {
        // Obtenemos los status de las ventas
        this.status = this.status.concat(this.getStasuses());
        this.isLoading = true;

        // Verificar si se quieren obtener las ventas de todas las sucursales
        if (this.selectedBranchId === -1 || this.getProfile.testing_orders) {
          // Realizar petición para todas las sucursales
          this.sales = await MovementsServices.getSalesByBusinessId(
            this.getProfile.business_id,
            page,
            this.selectedStatus
          );
        } else if (this.selectedBranchId) {
          // Realizar petición para la sucursal seleccionada
          this.sales = await MovementsServices.getSalesByBranchId(
            this.selectedBranchId,
            page,
            this.selectedStatus
          );
        }

        this.isLoading = false;
      } catch (err) {
        // Mostrar error
        this.onSalesError(err.message);
      }
    },
    branchChange: async function(id) {
      // Modificar la sucursal seleccionada
      this.selectedBranchId = id;

      // Obtener los datos de ventas
      await this.updatePage();
    },
    saleDeleted: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Venta eliminada con éxito");

      // Obtener ventas
      await this.updatePage();
    },
    onSalesError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    }
  }
};
</script>
